
import './App.css';
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import Main from './Main';
import NotFound from './Components/404/NotFound';
import Home from './Components/Home/Home';
import Login from './Components/Login/Login';
import Register from './Components/Register/Register';
import Course from './Components/Shared/Courses/Course';
import CoursesPages from './Components/Courses/CoursesPages';
import CourseDetails from './Components/Shared/Courses/CourseDetails';
import Checkout from './Components/Checkout/Checkout';
import Blog from './Components/Blog/Blog';
import { ToastContainer } from 'react-toastify';
import Profile from './Components/Profile/Profile';
import PrivateRoutes from './Components/PrivateRouter/PrivateRoutes';
import Faq from './Components/FAQ/Faq';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Main></Main>,
      children: [
        {
            path: '/',
            element: <Home></Home>,
            loader: () => {
              return fetch('https://assignment-10-server-rose-one.vercel.app/')
            }
        },
        {
          path: '/courses',
          loader: () => {
            return fetch('https://assignment-10-server-rose-one.vercel.app')
          },
          element: <CoursesPages></CoursesPages>
        
        },
        {
          path: '/courses/:id',
          loader: ({params}) => {
            return fetch(`https://assignment-10-server-rose-one.vercel.app/courses/${params.id}`)
          },
          element:<CourseDetails></CourseDetails>
        
        },
        {
          path: '/FAQ',
          element: <Faq></Faq>
        },
        {
          path: '/checkout',
          element: <PrivateRoutes><Checkout></Checkout></PrivateRoutes>
        },
        {
          path: '/blog',
          element: <Blog></Blog>
        },
        {
          path: '/login',
          element: <Login></Login>
        },
        {
          path: '/register',
          element: <Register></Register>
        },
        {
          path: '/profile',
          element: <PrivateRoutes><Profile></Profile></PrivateRoutes>
        },
        {
          path: '*',
          element: <NotFound></NotFound>
        }
      ]
    }
  ])
  return (
    <div className="App">

     <RouterProvider router={router}></RouterProvider>
     <ToastContainer />
    </div>
  );
}

export default App;
